import { Reveal, Eyebrow } from "./Reveal";
import { FileBarChart2, PhoneCall, Timer, MoonStar } from "lucide-react";

const reportImg =
  "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxkaXNwYXRjaCUyMG9mZmljZSUyMGNhbGwlMjBjZW50ZXIlMjBvcGVyYXRvciUyMGhlYWRzZXQlMjB3b3JrZXJ8ZW58MHx8fHwxNzkxMTI1MTE2fDA&ixlib=rb-4.1.0&q=85";

const metrics = [
  { icon: PhoneCall, value: "38", label: "missed calls recovered" },
  { icon: FileBarChart2, value: "$41,200", label: "booked job value" },
  { icon: Timer, value: "9s", label: "median response time" },
  { icon: MoonStar, value: "14", label: "after-hours saves" },
];

const bars = [42, 66, 30, 82, 56, 92, 70];

export default function WeeklyReport() {
  return (
    <section data-testid="weekly-report-section" className="relative border-t border-white/[0.06] bg-[#0E1117] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <Eyebrow>The Weekly Report</Eyebrow>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
            Every Monday, know exactly what Backfill earned you
          </h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-400">
            Owners get a plain-English summary by email and SMS: opportunities
            captured, jobs booked, response times, and recovered revenue — no
            dashboard archaeology required.
          </p>
          <div className="relative mt-9 overflow-hidden rounded-xl border border-white/[0.08]">
            <img
              src={reportImg}
              alt="Dispatch office operator at work"
              data-testid="report-image"
              className="h-56 w-full object-cover contrast-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0E1117] via-black/30 to-transparent" />
            <span className="absolute left-0 top-0 h-5 w-5 border-l-2 border-t-2 border-[#F25F22]" />
            <span className="absolute bottom-0 right-0 h-5 w-5 border-b-2 border-r-2 border-[#F25F22]" />
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            data-testid="executive-report-card"
            className="rounded-xl border border-white/[0.1] bg-[#12161F] shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)]"
          >
            <div className="flex items-center justify-between border-b border-white/[0.08] px-7 py-5">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#F25F22]">
                  Backfill Weekly
                </p>
                <p className="mt-1 font-display text-lg font-semibold text-slate-50">
                  Recovered Revenue Report
                </p>
              </div>
              <span className="rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-emerald-400">
                Jul 6 – 12
              </span>
            </div>

            <div className="grid grid-cols-2 gap-px bg-white/[0.06]">
              {metrics.map((m, i) => (
                <div key={m.label} className="bg-[#12161F] p-6" data-testid={`report-metric-${i}`}>
                  <m.icon className="h-4 w-4 text-[#F25F22]" />
                  <p className="mt-3 font-display text-2xl font-bold text-slate-50">
                    {m.value}
                  </p>
                  <p className="mt-1 text-xs text-slate-400">{m.label}</p>
                </div>
              ))}
            </div>

            <div className="border-t border-white/[0.08] px-7 py-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                Recovered calls by day
              </p>
              <div className="mt-4 flex h-24 items-end gap-2.5">
                {bars.map((h, i) => (
                  <div
                    key={i}
                    className="flex-1 rounded-sm bg-gradient-to-t from-[#F25F22]/40 to-[#F25F22] transition-all duration-300 hover:to-[#FF8A50]"
                    style={{ height: `${h}%` }}
                    data-testid={`report-bar-${i}`}
                  />
                ))}
              </div>
              <div className="mt-2 flex justify-between font-mono text-[10px] uppercase text-slate-600">
                <span>Mon</span>
                <span>Sun</span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
